import React, {useState} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import fp from 'lodash/fp';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import {DatePicker, TimePicker} from 'material-ui-pickers';
import SlotId from '../Inputs/SlotId';
import Comment from '../Inputs/Comment';
import SlotGroup from '../Forms/SlotGroup';
import useStyles from './styles';
import values from '../../prices';

const lteHead = value => fp.compose (fp.lte(value), fp.toNumber, fp.head)
const filterGt = fp.filter (fp.__, values)
const getValueByDistance = fp.compose (fp.last, fp.head, filterGt, lteHead)

const NewDelivery = ({submitForm}) => {

  const classes = useStyles();

  const [isBusy, setBusy] = useState(false);
  const [selectedDate, onDateChange] = useState(moment());

  const [slotGroup, _handleSlotChange] = useState([fp.cloneDeep(emptySlot)]);

  const handleSlotChange = idx => event => {
    event.persist && event.persist();

    const {name, value} = event.target;

    const setByName = fp.set ([idx, name], value)
    const setDistance = fp.set ([idx, 'distance'], value)
    const setValueByDistance = fp.set ([idx, 'value'], getValueByDistance(value))
    const setAutoValue = fp.compose (setValueByDistance, setDistance)

    const transformState = name === 'distance'
      ? setAutoValue
      : setByName;

    _handleSlotChange(transformState);
  };

  const [_id, _handleIdChange] = useState('');
  const handleIdChange = event => {
    event.persist && event.persist();
    _handleIdChange(event.target.value);
  };

  const [comment, _handleCommentChange] = useState('');
  const handleCommentChange = event => {
    event.persist && event.persist();
    _handleCommentChange(event.target.value);
  };

  const handleAddButton = idx => () => {

    const filterWithKey = fp.filter.convert({ 'cap': false });
    const newSlot = fp.cloneDeep(emptySlot)

    if (idx === slotGroup.length - 1) _handleSlotChange(fp.concat(fp.__, newSlot));
    else _handleSlotChange(filterWithKey((el, i) => i !== idx));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setBusy(true);
    await submitForm({_id, slotGroup, timestamp: _.toNumber(selectedDate.format('x')), comment});
    setBusy(false);
  };

  return (
    <form onSubmit={handleSubmit} className={classes.container}>
      <Grid container spacing={4}>

        <Grid item xs={12}>
          <Grid
            container
            justify='center'
            alignItems='center'
            className={classes.title}
          >
            <Typography variant='h6'>
              Nova Entrega
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <SlotGroup
            state={slotGroup}
            handleAddButton={handleAddButton}
            handleChange={handleSlotChange}
          />
        </Grid>

        <Grid item xs={12}>
          <SlotId
            fullWidth
            required
            value={_id}
            onChange={handleIdChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DatePicker
            name='date'
            label='Data'
            value={selectedDate}
            onChange={onDateChange}
            format={'DD/MM/YYYY'}
            className={classes.picker}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TimePicker
            name='time'
            label='Horário'
            value={selectedDate}
            onChange={onDateChange}
            ampm={false}
            className={classes.picker}
          />
        </Grid>

        <Grid item xs={12}>
          <Comment
            fullWidth
            value={comment}
            onChange={handleCommentChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            size='large'
            fullWidth
            className={classes.margin}
          >
            {
              isBusy
                ? <CircularProgress className={classes.spinner}/>
                : 'Salvar'
            }
          </Button>
        </Grid>

      </Grid>
    </form>
  );
};

NewDelivery.propTypes = {
  submitForm: PropTypes.func.isRequired
};

const emptySlot = {
  value: '',
  distance: '',
  weight: '',
  slotType: 'rp1a',
  slotNumber: 6,
  member: '',
  age: ''
};

export default NewDelivery;
